import { useEffect } from 'react'
import PageHeader from 'components/PageHeader'
import classNames from 'classnames'
import {
  fetchTracks,
  reset,
  setTab,
} from 'features/crux/tracker/list/trackerListSlice'
import LinkedTracks from 'features/crux/tracker/list/linked/LinkedTracks'
import UnLinkedTracks from 'features/crux/tracker/list/unlinked/UnLinkedTracks'
import { useDispatch, useSelector } from 'react-redux'
import CreateTrack from 'features/crux/tracker/modal/create/CreateTrack'
import Button from 'components/form/Button'
import Icon from 'components/Icon'
import {
  resetCreateTrack,
  showCreateTrackModal,
} from 'features/crux/tracker/modal/create/createTrackSlice'
import InstallTrack from 'features/crux/tracker/modal/create/InstallTrack'
import { useAlert } from 'features/dialog/Alert'
import { MAX_TRACKER_SIZE } from 'features/crux/tracker/Tracker'
import KakaoServiceTrack from 'features/crux/tracker/modal/kakaoService/KakaoServiceTrack'
import RequestTrack from 'features/crux/tracker/modal/request/RequestTrack'
import {
  hideRequestTrack,
  showRequestTrack,
} from 'features/crux/tracker/modal/request/requestTrackSlice'
import { hideKakaoServices } from 'features/crux/tracker/modal/kakaoService/kakaoServiceTrackSlice'
import { parse } from 'query-string'
import { Link, useLocation } from 'react-router-dom'

const { REACT_APP_BUSINESS_HOST } = process.env

const TrackerList = () => {
  const dispatch = useDispatch()
  const {
    tab,
    linkedTotalElements,
    unlinkedTotalElements,
    kakaoAccountIdLinkedCount,
    linkedLoading,
    unlinkedLoading,
  } = useSelector(state => state.tracker.trackerList)
  const { tab: param } = parse(useLocation().search)
  const [FailedCreateAlert, showFailedCreateAlert] = useAlert()
  const [FailedInviteAlert, showFailedInviteAlert] = useAlert()
  const isExceeded = kakaoAccountIdLinkedCount >= MAX_TRACKER_SIZE

  useEffect(() => {
    if (param === 'unlinked') {
      dispatch(setTab('unlinked'))
    } else {
      dispatch(setTab('linked'))
    }
  }, [param, dispatch])
  useEffect(() => {
    dispatch(fetchTracks())
  }, [dispatch])
  useEffect(
    () => () => {
      dispatch(reset())
      dispatch(resetCreateTrack())
      dispatch(hideKakaoServices())
      dispatch(hideRequestTrack())
    },
    [dispatch]
  )

  return (
    <>
      <div className="pixelsdk_wrap">
        <div className="dsp_tit pixelsdk_tit">
          <PageHeader pageTitle="픽셀&SDK 연동 관리" />
        </div>
        <ul className="list_append">
          <li>광고계정에서 사용할 수 있는 픽셀 &amp; SDK 목록입니다.</li>
          <li>
            광고계정에서 사용하고 싶은 픽셀 &amp; SDK가 있으면 ‘픽셀 &amp; SDK
            만들기’ 또는 ‘멤버 권한 요청’을 하세요.
          </li>
        </ul>
        <div className="ad_managebox">
          <ul className="tab_g" role="tablist">
            <li
              role="presentation"
              className={classNames({ on: tab === 'linked' })}>
              <Link to="?tab=linked" role="tab" className="link_tab">
                연동 중인 픽셀 &amp; SDK{' '}
                <em className="fc_emph">{linkedTotalElements}</em>
              </Link>
            </li>
            <li
              role="presentation"
              className={classNames({ on: tab === 'unlinked' })}>
              <Link to="?tab=unlinked" role="tab" className="link_tab">
                연동 가능한 픽셀 &amp; SDK{' '}
                <em className="fc_emph">{unlinkedTotalElements}</em>
              </Link>
            </li>
          </ul>
          <div className="tab_right">
            <div className="single_wrap">
              <Button
                primary
                onClick={() => {
                  if (isExceeded) {
                    showFailedCreateAlert()
                  } else {
                    dispatch(showCreateTrackModal())
                  }
                }}
                disabled={linkedLoading || unlinkedLoading}>
                <Icon className="img_comm" name="add" />
                픽셀 &amp; SDK 만들기
              </Button>
            </div>
            <div className="single_wrap">
              <Button
                line
                onClick={() => {
                  if (isExceeded) {
                    showFailedInviteAlert()
                  } else {
                    dispatch(showRequestTrack())
                  }
                }}
                disabled={linkedLoading || unlinkedLoading}>
                멤버 권한 요청
              </Button>
            </div>
            <div className="single_wrap">
              <a
                href={`${REACT_APP_BUSINESS_HOST}/pixel`}
                className="btn_gm gm_line"
                target="_blank"
                rel="noopener noreferrer">
                <span className="inner_g">픽셀&amp;SDK</span>
              </a>
            </div>
          </div>
          {tab === 'linked' && <LinkedTracks />}
          {tab === 'unlinked' && <UnLinkedTracks />}
        </div>
      </div>
      <CreateTrack />
      <InstallTrack />
      <KakaoServiceTrack />
      <RequestTrack />
      <FailedCreateAlert title="픽셀 & SDK 만들기 불가">
        사용할 수 있는 픽셀 & SDK 제한 수를 초과하여
        <br />
        픽셀 & SDK 만들기가 불가합니다. 기존 픽셀 & SDK를
        <br />
        삭제하거나 멤버 나가기 한 후 다시 시도하세요.
      </FailedCreateAlert>
      <FailedInviteAlert title="멤버 권한 요청 불가">
        사용할 수 있는 픽셀 & SDK 제한 수를 초과하여 멤버
        <br />
        권한 요청이 불가합니다. 기존 픽셀 & SDK를 삭제하거나
        <br />
        멤버 나가기 한 후 다시 시도하세요.
      </FailedInviteAlert>
    </>
  )
}

export default TrackerList
